import React from 'react';
import WizardShell from './wizard-shell';
import { Button } from './button';

export type ConfirmWizardModalProps = {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  title: React.ReactNode;
  description?: React.ReactNode;
  body?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => Promise<void> | void;
  isLoading?: boolean;
};

export default function ConfirmWizardModal({
  open,
  onOpenChange,
  title,
  description,
  body,
  confirmLabel = 'Bestätigen',
  cancelLabel = 'Abbrechen',
  onConfirm,
  isLoading = false,
}: ConfirmWizardModalProps) {
  return (
    <WizardShell
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      contentClassName="w-[1080px] h-[630px] max-w-[95vw] max-h-[95vh]"
      footer={
        <div className="flex w-full items-center justify-between gap-3">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={() => {
              void Promise.resolve(onConfirm());
            }}
            disabled={isLoading}
          >
            {confirmLabel}
          </Button>
        </div>
      }
    >
      <div className="py-4">
        {body ? body : <div className="text-sm text-muted-foreground">Bitte bestätigen Sie diese Aktion.</div>}
      </div>
    </WizardShell>
  );
}


